import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from './IELTSCourse';
import { readingStrategiesData, getDataForDifficulty } from './data/skills/reading/readingStrategies';

export default function ReadingStrategies() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : readingStrategiesData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
